module.exports = __webpack_public_path__ + "static/pomo-262abb838d243f1249137a7c314e6e5e.png";